module.exports = __webpack_public_path__ + "img/Group-Two.097447cd.svg";